/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoRequestCustomTravelEmail } from '../../models/dto-request-custom-travel-email';

export interface CommonControllerCreateTravelRequest$Params {
      body: DtoRequestCustomTravelEmail
}

export function commonControllerCreateTravelRequest(http: HttpClient, rootUrl: string, params: CommonControllerCreateTravelRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, commonControllerCreateTravelRequest.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

commonControllerCreateTravelRequest.PATH = '/common/travel-request';
